<div class="reminder-main-container input d-flex justify-content-start align-items-center">
  <div class="toggle-container">
    <ion-toggle class="toggle-btn" [(ngModel)]="value.reminder" (ionChange)="onToggleChange()"></ion-toggle>
  </div>
  <div class="date-container">
    <app-date-picker 
      [minDate]="minDate" 
      [maxDate]="maxDate" 
      [(ngModel)]="value.date" 
      [disabled]="!value.reminder"
      (ngModelChange)="onDateChange($event)">
    </app-date-picker>
  </div>
  <div class="time-container">
    <app-time-picker 
      [(ngModel)]="value.time" 
      [disabled]="!value.reminder"
      (ngModelChange)="onTimeChange($event)">
    </app-time-picker>
  </div>
</div>
